export const PORTAL_CONTAINER_ATTRIBUTE = 'alfa-portal-container';
